<template lang="html">
  <!-- Remember to put &nbsp; after each period as Brad prefers two spaces instead of one before new sentence -->
  <div style="background-color: #ffffff;">
    <v-container justify-center wrap fluid class="description-container">
      <v-layout justify-center wrap>
        <v-flex xs12 sm10 md8 lg6>
          <h1 class="description-title">Join our talented team</h1>

          <v-flex mt-4>
            <p class="body-text">We are always looking for talented artists, software engineers and mathematicians. &nbsp;If you're interested in joining our team of brilliant, passionate, and skilled associates, get in touch with us today.</p>
          </v-flex>

          <v-flex mt-4>
            <p class="body-text">To be considered for any openings listed below, please apply online (available within the applicable job description).</p>
          </v-flex>

          <v-flex mt-4 align-center justify-center row class="career-email">
            <img src="../assets/Icon_Mail.svg" height="22px" />
            <p class="body-text" style="color: white; margin: 0; padding-left: 0.5rem;">Careers:</p>
            <a href="mailto:careers@blitzoo.com" target="_top" class="body-text" style="margin-left: 1rem; color: white;">careers@blitzoo.com</a>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>

    <section class="career-text-container mt-3">
      <v-container>
        <!-- Blitzoo -->
        <v-layout row justify-center>
          <!-- <v-flex xs12 sm10 md8 lg6 xl4 justify-start class="text-xs-left font-weight-bold" :class="{ 'mt-5': firstOrder }" id="title"> -->
          <v-flex xs12 sm10 md8 lg6 xl4 justify-center class="text-xs-center font-weight-bold" id="title">
            <h3 class="career-subtitle">Current Positions Available at Blitzoo</h3>
          </v-flex>
        </v-layout>

        <v-layout row justify-center>
          <v-flex xs12 sm10 md8 lg6 xl4 justify-center>
            <div id="BambooHR" data-domain="blitzoo.bamboohr.com" data-version="1.0.0" data-departmentId=""></div>
          </v-flex>
        </v-layout>
    </v-container>
  </section>
</div>
</template>

<script>
export default {
  name: 'Career',
  data () {
    return {
      publicPath: process.env.BASE_URL,
      search: '',
      headers: [
        { text: 'Position', value: 'position', align: 'left' },
        { text: 'Department', value: 'department', align: 'center' },
        { text: 'Location', value: 'location', align: 'right' }
      ],
      jobs: [
        {
          position: 'Lead DevOps Engineer (Mtka)',
          department: 'Infrastructure & Operations',
          location: 'Minnetonka, MN',
          description: '<p>King Show Games, Inc., a video game development company, is currently interviewing qualified applicants interested in pursuing a career in video game development. &nbsp;We are looking for people who are innovative, talented, creative, and passionate about the gaming industry. &nbsp;If you’re a self-motivated team player who is able to multi-task and can handle the following responsibilities, we look forward to hearing from you!</p><h3>Job Summary</h3><p>Work collaboratively with our Team to develop and maintain a robust, high performance and cost-effective infrastructure capable of supporting 1 million daily active users (at a minimum) while supporting the development needs of multiple developers in multiple locations. &nbsp;Applicants should be keen to solve problems, optimize performance and improve reliability in all aspects of our technology stack.</p><h3>Responsibilities</h3><ul><li>Develop and maintain a high-performance and robust production infrastructure with close to zero down time.</li><li>Develop and maintain a robust build pipeline capable of meeting the daily build requirements of engineers, producers and the quality assurance team.</li><li>Interact with the engineering team to ensure the infrastructure is structured in such a way to optimize the performance and reliability of the underlying code.</li><li>Develop and maintain appropriate monitoring tools to report against infrastructure performance.</li><li>Monitor and report against all elements of the infrastructure.</li><li>Research new technology where necessary to meet business needs.</li></ul><br><h3>Qualifications Required</h3><ul><li>BS in Computer Science or equivalent education / experience.</li><li>At least 5 years as a DevOps engineer, preferably in the business-to-consumer (B2C) gaming industry.</li><li>Experience with Amazon Web Services (EC2, ELB, Cloudfront, Cloudwatch, S3), NoSQL Databases (MongoDB), Docker, Service registration and Discovery systems (Kubernetes), Git, CICD systems (Jenkins), System performance tuning (JVM), Systems and applications monitoring (New Relic).</li><li>Experience with scripting/interpreted languages such as BASH, PERL, Go, Javascript, Python or Ruby are an asset.</li><li>Candidates must be highly responsive and be willing to respond to operational issues promptly, both inside and outside of office hours.</li><li>Candidates must have excellent organizational skills, good oral and written communications skills, and a high level of interpersonal skills.</li><li>Must be a self-motivated team player with the ability to work in a customer oriented, very fast-paced, and demanding environment.</li><li>Ability to bring projects to completion with minimal supervision.</li><li>Must be able to meet or exceed set project milestones and deadlines, which will entail extra work time as needed (work hours beyond a normal work week).</li></ul><br><p>While this role requires the ability to manage Live Operations, we are associate/family friendly and recognize the importance of work/life balance.</p><p>This job description should not be interpreted as all-inclusive; it is intended to identify major responsibilities and requirements of the job. &nbsp;Team members may be requested to perform other job-related tasks and responsibilities other than those stated above.</p>',
          company: '<h3>About King Show Games</h3><p>Founded in 1998, King Show Games is a Minnesota based company providing entertaining video games that are played around the world. &nbsp;Our growing company consists of talented artists, engineers, mathematicians and producers that have created over 200 games. &nbsp;Our Company Belief consists of 4 principals:</p><ul><li><strong>THINK BIG</strong> – Think outside the box; strive to be successful.</li><li><strong>BE FRANK</strong> – Be open and sincere in your dealings with others; be forthright.</li><li><strong>FIGHT HARD</strong> – Believe in your ideas; speak up for your convictions.</li><li>After the call, <strong>MOVE AS A TEAM!</strong></li></ul><br><p>King Show Games offers competitive salaries and a full range of comprehensive benefits including a bonus plan, medical, dental, life and long-term disability insurance, as well as a matching 401k.</p><p>King Show Games is an equal opportunity employer.</p><hr>',
          candidate: "<p>Candidates only apply. &nbsp;Recruiters please don't contact King Show Games. &nbsp;<br>Please, no phone calls about this job! <br>Please do not contact King Show Games about other services, products or commercial interests.</p>",
          code: ''
        }
      ],
      firstOrder: true
    }
  },
  computed: {
    mobile () {
      return navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ||
        navigator.userAgent.toLowerCase().indexOf('android') > -1
    }
  },
  methods: {
    carouselLeftClick () {
      if (this.currentCard === 0) {
        this.currentCard = this.employees.length - 1
      } else {
        this.currentCard -= 1
      }
    },
    carouselRightClick () {
      if (this.currentCard === this.employees.length - 1) {
        this.currentCard = 0
      } else {
        this.currentCard += 1
      }
    },
    cleanupBamboo () {
      const el = document.getElementById('BambooHR')
      if (el) el.innerHTML = ''

      const s = document.querySelectorAll('script[data-bamboo-embed="1"]')
      if (s.length > 0) s.forEach(s => s.remove())
    },
    loadScript (src) {
      return new Promise((resolve, reject) => {
        const s = document.createElement('script')
        s.src = src
        s.type = 'text/javascript'

        // defer is ignored for dynamically inserted scripts
        s.async = false
        s.defer = false
        s.dataset.bambooEmbed = '1'

        s.onload = () => resolve()
        s.onerror = () => reject(new Error(`Failed to load ${src}`))

        document.head.appendChild(s)
      })
    },
    async renderBamboo () {
      // make sure the BambooHR div is in the DOM
      await this.$nextTick()
      const container = document.getElementById('BambooHR')
      if (!container) return console.warn('[BambooHR] container not found')

      // reset any previous run
      this.cleanupBamboo()

      // re-inject the script so it scans the DOM again
      await this.loadScript(`https://blitzoo.bamboohr.com/js/embed.js?cb=${Date.now()}`)

      // force event to trigger script manually
      if (document.readyState === 'complete') {
        document.dispatchEvent(new Event('readystatechange'))
      }
    }
  },
  mounted () {
    this.renderBamboo()
  },
  activated () {
    this.renderBamboo()
  },
  beforeDestroy () {
    this.cleanupBamboo()
  }
}
</script>

<style lang="scss" scoped>
.description-container {
  background-image: url('../assets/careers/Header_Careers.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}

.description-title {
  font-family: 'open-sans-extrabold', serif;
  font-weight: 700;
  font-size: 50px;
  letter-spacing: -2px;
  line-height: 1.15;
}

.career-container {
  background-color: rgba(246, 130, 31, 0.2);
}

.career-title {
  font-family: museo-slab, serif;
  // font-style: italic;
  font-weight: 700;
  font-size: 30px;
  color: #f6821f;
  letter-spacing: -2px;
}

.career-subtitle {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 22px;
  color: #12013a;
  display: inline-block;
  // margin-left: 0.5rem;
}

.career-subtitle-updated {
  font-family: museo-slab, serif;
  display: inline-block;
  margin-left: 0.5rem;
}

.body-text {
  font-size: 18px;
}

.career-email {
  display: flex;
}

.email-style {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 700;
  color: #5677c3;
  text-decoration: none;
  font-size: 18px;
}

.table-position {
  font-family: lato, serif;
  font-style: normal;
  font-weight: 500;
  // font-size: 18px;
  color: #f6821f;
}

#title {
  margin-bottom: 2rem;
}

/* increase font size in BambooHR embed content */
::v-deep .BambooHR-ATS-Department-Header,
::v-deep .BambooHR-ATS-Location {
  font-size: 1rem;
}

::v-deep .BambooHR-ATS-Jobs-Item > a {
  color: #b000ff;
}

</style>
